import { lang } from '../../assets/lang'

export const carouselItemHtml =
'<div id="file-upload-media-url-group" class="form-group text-left mt-2">' + 
  '<label for="file-upload-media-url">' + lang.carousel_item_html_label_reply_img + '</label>' +
  '<input type="text" class="form-control" id="file-upload-media-url" placeholder="' + lang.carousel_item_html_ph_media_url + '">' +
'</div>' +

'<div class="form-group fb-file-upload mt-4">' +
'<div id="file-upload-dropzone" class="dropzone d-flex justify-content-center align-items-center mb-1">' +
  '<div class="dz-default dz-message">' +
    '<input type="file" class="d-none" name="uploaded-file-file" id="uploaded-file-file">' +
    '<i class="fas fa-cloud-upload-alt"></i>' +
  '</div>' +
'</div>' +
'<small class="text-muted supported_image">' + lang.carousel_item_html_info_supported_img + '</small>' +
'</div>' +

'<div class="form-group text-left mb-0 mt-2">' + 
'<label for="carousel-item-image-link">' + lang.carousel_item_html_label_destination_link + '</label>' +
'<input type="text" class="form-control" id="carousel-item-image-link" aria-describedby="carousel-item-image-link-help">' +
'</div>' +

'<div class="form-group text-left mb-0 mt-2">' + 
'<label for="carousel-item-title">' + lang.carousel_item_html_label_title + '</label>' +
'<input type="text" class="form-control" id="carousel-item-title" aria-describedby="carousel-item-title-help">' +
'</div>' +

'<div class="form-group text-left mb-0 mt-2">' + 
'<label for="carousel-item-subtitle">' + lang.carousel_item_html_label_subtitle + '</label>' +
'<input type="text" class="form-control" id="carousel-item-subtitle" aria-describedby="carousel-item-subtitle-help">' +
'</div>'